import { render, staticRenderFns } from "./dashboardoutline2.vue?vue&type=template&id=8cfe5e10&scoped=true&"
import script from "./dashboardoutline2.vue?vue&type=script&lang=js&"
export * from "./dashboardoutline2.vue?vue&type=script&lang=js&"
import style0 from "./dashboardoutline2.vue?vue&type=style&index=0&id=8cfe5e10&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfe5e10",
  null
  
)

export default component.exports